export default "__VITE_ASSET__wKPmoKmN__"